import React, { useState, useEffect } from "react";

import { useAuth } from "../../contexts/AuthContext";
import { apiClient } from "../../utils/apiClient/index.ts";
import DocumentsTab from "../Cases/components/DocumentsTab";

export const ClientDocuments: React.FC = () => {
  const { currentUser } = useAuth();
  const [selectedCaseId, setSelectedCaseId] = useState<string | null>(null);
  const [cases, setCases] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAssignedCases();
  }, []);

  const loadAssignedCases = async () => {
    setLoading(true);
    try {
      const assignedCases = await apiClient.getAssignedCases();
      setCases(assignedCases);

      // Auto-select first case if available
      if (assignedCases.length > 0 && !selectedCaseId) {
        setSelectedCaseId(assignedCases[0].id);
      }
    } catch (error) {
      console.error("Failed to load assigned cases:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-gray-600 dark:text-gray-400">Loading...</div>
      </div>
    );
  }

  if (cases.length === 0) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-12 text-center dark:border-gray-800 dark:bg-white/[0.03]">
        <h3 className="text-lg font-semibold text-black dark:text-white mb-2">
          No Cases Assigned
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          You don't have any cases assigned yet. Contact your attorney for more
          information.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
        <h1 className="mb-2 text-title-md2 font-semibold text-black dark:text-white">
          My Documents
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Access and manage your case files
        </p>

        {/* Case Selector */}
        {cases.length > 1 && (
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Select Case
            </label>
            <select
              value={selectedCaseId || ""}
              onChange={(e) => setSelectedCaseId(e.target.value)}
              className="w-full max-w-md px-4 py-2.5 border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-black dark:text-white focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent outline-none"
            >
              {cases.map((caseItem) => (
                <option key={caseItem.id} value={caseItem.id}>
                  {caseItem.title}
                </option>
              ))}
            </select>
          </div>
        )}

        {cases.length === 1 && (
          <div className="text-sm text-gray-600 dark:text-gray-400">
            <span className="font-medium">Case:</span> {cases[0].title}
          </div>
        )}
      </div>

      {/* File Manager */}
      {selectedCaseId && (
        <DocumentsTab
          caseId={selectedCaseId}
          orgId={currentUser?.organizations[0].id!}
        />
      )}
    </div>
  );
};
